module.exports = __webpack_public_path__ + "img/artists-carrousel-5.d50a3dba.png";